import { FeatureFlag } from '@/features/standortContext/entities/featureFlag';

export class Standort {
  constructor({
    id,
    uid,
    idStandortgruppe,
    name,
    abteilungenEnabled,
    isMonatAbgeschlossen,
    storeNummer,
    isTerminVerknuepfung,
    featureFlags,
    land,
    isAuditAktiv = false,
    qualifikationenEnabled = false,
    isGuttagekontenAktiviert = false,
  }: {
    id: string;
    uid: string;
    idStandortgruppe: string;
    name: string;
    abteilungenEnabled?: boolean;
    isMonatAbgeschlossen?: boolean;
    storeNummer?: string;
    isTerminVerknuepfung?: boolean;
    featureFlags: FeatureFlag[];
    land: string;
    isAuditAktiv?: boolean;
    qualifikationenEnabled?: boolean;
    isGuttagekontenAktiviert?: boolean;
  }) {
    this.id = id;
    this.uid = uid;
    this.idStandortgruppe = idStandortgruppe;
    this.name = name;
    this.abteilungenEnabled = abteilungenEnabled;
    this.isMonatAbgeschlossen = isMonatAbgeschlossen;
    this.storeNummer = storeNummer;
    this.isTerminVerknuepfung = isTerminVerknuepfung;
    this.featureFlags = featureFlags;
    this.land = land;
    this.isAuditAktiv = isAuditAktiv;
    this.qualifikationenEnabled = qualifikationenEnabled;
    this.isGuttagekontenAktiviert = isGuttagekontenAktiviert;
  }

  readonly id: string;
  readonly uid: string;
  readonly idStandortgruppe: string;
  readonly name: string;
  readonly storeNummer?: string;
  readonly abteilungenEnabled?: boolean;
  readonly isTerminVerknuepfung?: boolean;
  readonly isMonatAbgeschlossen?: boolean;
  readonly featureFlags: FeatureFlag[];
  readonly land: string;
  readonly isAuditAktiv: boolean;
  readonly qualifikationenEnabled: boolean;
  readonly isGuttagekontenAktiviert: boolean;
}
